export default __webpack_public_path__ + "static/media/1132.912232bb.png";